import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb37bd0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-head-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "table-row01" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "align-left-box first-row-box" }, [
      /*#__PURE__*/_createElementVNode("div", null, "商品信息"),
      /*#__PURE__*/_createElementVNode("div", null, "单价(元) / 数量")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "table-row02" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "align-left-box" }, "售后状态")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "table-row03" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "align-left-box" }, "实收金额(元)")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "table-row04" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "align-left-box" }, "买家 / 收货人")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "table-row05" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "align-left-box" }, "配送方式")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "table-row06" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "align-left-box" }, "订单状态")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "table-row07" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "align-right-box" }, "操作")
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, _hoisted_3))
}